import React, { useState, useEffect } from "react";
import {
    Button, Modal, Input, Select, Empty, message, Radio, Space
} from "antd";
import {
    CloseOutlined, ArrowLeftOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import RenderComponent from "../General/RenderComponent";
import OneIntelligenceServices from "../../services/OneIntelligence.services";
import AudienceServices from "../../services/Audience.services";
import { setVisibleAddAudienceModal } from "../../store/components/Reports.slice";
import { setAdvertiserList, setLOBList } from "../../store/components/Audience.slice";
import { getCountryCode, getServer } from "../../utils/oneintelligence/OneIntelligenceHelper";
import MainServices from "../../services/Main.services";
import TreeServices from "../../services/Tree.services";
import useSearchInTree from "../../hooks/Tree/useSearchInTree";
import TrackFeatureServices from "../../services/TrackFeature.services";

function AddAudienceModal({
    visible
}) {
    const dispatch = useDispatch();

    const {
        visibleAddAudienceModal: {
            toAddNewAudience: data,
            toAddNewAudienceName,
            trackKey
        },
    } = useSelector((state) => state.reports);
    const {
        setup: {
            marketPackage
        }
    } = useSelector((state) => state.buildTargets);
    const { mode } = useSelector((state) => state.reportBuilder);

    const [isLoadingAdvertiser, setisLoadingAdvertiser] = useState(false);
    const [isLoadingLOB, setisLoadingLOB] = useState(false);
    const [isLoadingAudienceList, setisLoadingAudienceList] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [createNew, setCreateNew] = useState(false);
    const [advList, setAdvList] = useState([]);
    const [LOBList, setLobList] = useState([]);
    const [audienceList, setAudienceList] = useState([]);
    const [selectedAdv, setSelectedAdv] = useState(null);
    const [selectedLOB, setSelectedLOB] = useState(null);
    const [selectedAudience, setSelectedAudience] = useState(null);
    const [audienceName, setAudienceName] = useState("");
    const [searchText, setSearchText] = useState("");

    const { loadingSearch, searchedData } = useSearchInTree(searchText, audienceList);
    const toDisplayAudience = searchText ? searchedData : audienceList

    const onClose = () => {
        dispatch(setVisibleAddAudienceModal({
            visible: false,
            trackKey: "",
            toAddNewAudience: [],
            toAddNewAudienceName: "",
        }));
    };

    useEffect(() => {
        if (visible) {
            const { accountDetails: { id } } = MainServices.userDetails();
            const setDefault = (tempList) => {
                const found = tempList.find((item) => item.id === id);
                if (found) {
                    setSelectedAdv({
                        label: found.name,
                        value: found.id
                    });
                } else if (tempList[0]) {
                    setSelectedAdv({
                        label: tempList[0].name,
                        value: tempList[0].id
                    });
                }
            };
            setisLoadingAdvertiser(true);
            AudienceServices.getAdvertiser().then((resp) => {
                setisLoadingAdvertiser(false);
                setAdvList(resp);
                setDefault(resp);
                dispatch(setAdvertiserList(resp));
            });
        }
    }, [visible]);

    useEffect(() => {
        if (selectedAdv) {
            const setDefault = (tempList) => {
                if (tempList[0]) {
                    setSelectedLOB({
                        label: tempList[0].name,
                        value: tempList[0].id
                    });
                }
            };
            setisLoadingLOB(true);
            setSelectedLOB(null);
            AudienceServices.getAdvertiserLOB(selectedAdv.value).then((resp) => {
                setisLoadingLOB(false);
                const newLOBList = resp.filter((item) => item.client_id)
                setLobList(newLOBList);
                dispatch(setLOBList({ account: selectedAdv.value, list: newLOBList }));
                setDefault(newLOBList);
            });
        }
    }, [selectedAdv]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (selectedAdv?.value && selectedLOB?.value) {
                setisLoadingAudienceList(true);
                AudienceServices.getAudienceList(selectedAdv, selectedLOB).then((data) => {
                    setisLoadingAudienceList(false);
                    setAudienceList(data.audiencepackages);
                });
            }
        }, 500)

        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [selectedAdv, selectedLOB]);

    const getParseData = () => data.reduce((acc, d) => {
        if (d.score !== undefined
            || d.share !== undefined
            || d.item !== undefined
            || d.masterSize !== undefined
            || d.audienceIntersect !== undefined
            || d.mastersName !== undefined
            || d.behaviormatch !== undefined
        ) {
            const childList = d.tempChildren || d.children;
            let category = d.discoveredCategory;
            let subcategory = "";
            let microsegment = "";
            if (childList?.length) {
                const [fChild] = childList;
                if (fChild.lvl === 3) {
                    const [categoryPath, subCategoryPath] = fChild.parentPath.split("/");
                    if (categoryPath.split("~~").length > 1) {
                        category = categoryPath.split("~~")[1];
                    } else {
                        category = categoryPath;
                    }
                    if (subCategoryPath.split("~~").length > 1) {
                        subcategory = subCategoryPath.split("~~")[1];
                    } else {
                        subcategory = subCategoryPath;
                    }
                } else if (fChild.lvl === 4) {
                    const [categoryPath, subCategoryPath, microsegmentPath] = fChild.parentPath.split("/");
                    if (categoryPath.split("~~").length > 1) {
                        category = categoryPath.split("~~")[1];
                    } else {
                        category = categoryPath
                    }
                    if (subCategoryPath.split("~~").length > 1) {
                        subcategory = subCategoryPath.split("~~")[1];
                    } else {
                        subcategory = subCategoryPath
                    }
                    if (microsegmentPath.split("~~").length > 1) {
                        microsegment = microsegmentPath.split("~~")[1];
                    } else {
                        microsegment = microsegmentPath
                    }
                }
            } else if (d.path) {
                const [categoryPath, subCategoryPath, microsegmentPath] = d.path.split("/");
                if (categoryPath.split("~~").length > 1) {
                    category = categoryPath.split("~~")[1];
                } else {
                    category = categoryPath
                }
                if (subCategoryPath.split("~~").length > 1) {
                    subcategory = subCategoryPath.split("~~")[1];
                } else {
                    subcategory = subCategoryPath
                }
                if (microsegmentPath.split("~~").length > 1) {
                    microsegment = microsegmentPath.split("~~")[1];
                } else {
                    microsegment = microsegmentPath
                }
            }
            if (!acc.checker[d.item]) {
                acc.checker[d.item] = true;
                acc.list.push({
                    topic: d.topic,
                    item: d.item,
                    score: d.score,
                    share: d.share,
                    group: d.group,
                    key: d.key,
                    color: d.color,
                    bg: d.bg,
                    word_translation: d.wordTranslation,
                    master_size: d.masterSize,
                    audience_intersect: d.audienceIntersect,
                    master_name: d.mastersName,
                    behavior_match: d.behaviormatch,
                    min_cpm: 0,
                    max_cpm: 0,
                    analysistype: d.analysistype,
                    category,
                    subcategory,
                    microsegment,
                    taget_audience: d.targetAudience
                });
            }
        }
        return acc;
    }, { list: [], checker: {} }).list;

    const onCreateNew = async () => {
        if (!audienceName) {
            message.warning("Please input Audience Name.");
            return;
        }
        const foundLob = LOBList.find((item) => item.id === selectedLOB.value);
        const countryObj = getServer();
        const { url, xmlAvailable, urlXML } = countryObj

        const requestObj = {
            data: {
                keyword_path: TreeServices.getTreePath(),
                savant_url: xmlAvailable ? urlXML : url,
                lob_id: selectedLOB.value.split("~")[1],
                advertiser_code: selectedAdv.value.split("~")[1],
                name: audienceName,
                country_code: getCountryCode("savant"),
                client_id: foundLob.client_id || "",
                market_package: marketPackage.parent.code,
                module: marketPackage.code,
                module_name: marketPackage.name || marketPackage.title,
                behaviors: getParseData(),
                // analysistype: mode,
                creation_type: toAddNewAudienceName ? "Recommended" : "Custom"
            }
        };

        const createAudienceApi = async () => {
            try {
                setIsSaving(true);

                const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: trackKey })
                let tempUrl = ""
                const monitorCallBack = (params, url) => {
                    tempUrl = url
                    startMonitor(params, { url: tempUrl })
                }
                const resp = await AudienceServices.createNewAudience(requestObj, data, monitorCallBack);
                setIsSaving(false);
                console.log(resp);
                endMonitor(resp, { url: tempUrl })
                message.success("Successfully create Audience Package.");
                onClose(false);
            } catch (error) {
                setIsSaving(false);
                console.log(error);
                message.error("Something went wrong while saving.");
            }
        };
        createAudienceApi();
    };
    const onUpdate = async () => {
        try {
            setIsSaving(true);
            const { url } = getServer();
            const found = audienceList.find((item) => item.id === selectedAudience);
            const newtrackKey = trackKey.replace("Create", "Update");

            const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: newtrackKey })
            let tempUrl = ""
            const monitorCallBack = (params, url) => {
                tempUrl = url
                startMonitor(params, { url: tempUrl })
            }
            const resp = await AudienceServices.updateAudience({ id: selectedAudience, savant_url: url }, getParseData(), data, monitorCallBack);
            console.log(resp);
            endMonitor(resp, { url: tempUrl })
            message.success(`Successfully added behavior in ${found.name} Package.`);
            setIsSaving(false);
            onClose(false);
        } catch (error) {
            setIsSaving(false);
            console.log(error);
            message.error("Something went wrong while saving.");
        }
    };
    const onChangeAdvertiser = (e, params) => {
        setSelectedAdv(params);
    };
    const onChangeLOB = (e, params) => {
        setSelectedLOB(params);
    };
    return (
        <Modal
            className="report--addaudience"
            style={{ width: "100%", height: "100%" }}
            open={visible}
            maskClosable={false}
            closable={false}
            title={(
                <div className="d-flex align-items-center" style={{ width: "100%" }}>
                    <div className="d-flex-col align-items-start justify-content-start" style={{ width: "100%" }}>
                        <span
                            className="flex-1 ellipsis-text fs-18 fw-600 c-bg-600"
                        >
                            {`${data.length} Segments Selected`}
                        </span>
                        <span
                            className="flex-1 ellipsis-text fs-14 fw-400 c-bg-400"
                        >
                            Add your selected segments to audience package.
                        </span>
                    </div>
                    {!isSaving && (
                        <Button
                            style={{ padding: 0, marginLeft: "5mm" }}
                            type="text"
                            icon={<CloseOutlined />}
                            onClick={() => {
                                onClose(false);
                            }}
                        />
                    )}

                </div>
            )}
            footer={(
                <div className="d-flex justify-content-end">
                    <Button onClick={() => { onClose(false); }} disabled={isSaving}>
                        Cancel
                    </Button>
                    {createNew ? (
                        <Button
                            type="primary"
                            loading={isSaving}
                            onClick={onCreateNew}
                        >
                            Save
                        </Button>
                    ) : (
                        <Button
                            type="primary"
                            disabled={!selectedAudience}
                            loading={isSaving}
                            onClick={onUpdate}
                        >
                            Add to Audience Package
                        </Button>
                    )}

                </div>
            )}
        >
            <div className="d-flex-col gap-1 report--addaudience--content">
                {createNew ? (
                    <>
                        <div className="d-flex gap-5p justify-content-start">
                            <Button
                                type="link"
                                icon={<ArrowLeftOutlined />}
                                onClick={() => {
                                    setCreateNew(false);
                                }}
                                style={{
                                    padding: "1mm"
                                }}
                                disabled={isSaving}
                            >
                                Back
                            </Button>
                        </div>
                        <div className="d-flex-col gap-5p">
                            <span className="fw-500 fs-14 c-bg-500">Audience Package Name</span>
                            <Input
                                onChange={(e) => {
                                    setAudienceName(e.target.value);
                                }}
                                value={audienceName}
                            />
                        </div>
                    </>
                )
                    : (
                        <>
                            {/* <Alert message="Message about the required minimum behavioral segment." type="warning" showIcon /> */}
                            <div className="d-flex-col gap-5p">
                                <span className="fw-500 fs-14 c-bg-500">Advertiser</span>
                                <Select
                                    disabled={isSaving}
                                    value={selectedAdv?.value}
                                    loading={isLoadingAdvertiser}
                                    showSearch
                                    placeholder={isLoadingLOB ? "Loading Advertiser" : "Select Advertiser"}
                                    optionFilterProp="children"
                                    onChange={onChangeAdvertiser}
                                    // onSearch={onSearchAdvertiser}
                                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                                    options={advList.map((item) => ({
                                        value: item.id,
                                        label: item.name
                                    }))}
                                />
                            </div>
                            <div className="d-flex-col gap-5p">
                                <span className="fw-500 fs-14 c-bg-500">Line of Business</span>
                                <Select
                                    disabled={isSaving}
                                    value={selectedLOB?.value}
                                    showSearch
                                    placeholder={isLoadingLOB ? "Loading Line of Business" : "Select Line of Business"}
                                    optionFilterProp="children"
                                    loading={isLoadingLOB}
                                    onChange={onChangeLOB}
                                    // onSearch={onSearch}
                                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                                    options={LOBList.map((item) => {
                                        return {
                                            value: item.id,
                                            label: item.name
                                        }
                                    })}
                                />
                            </div>
                            <div className="d-flex-col gap-5p">
                                <span className="fw-500 fs-14 c-bg-500">
                                    Select your package to add behaviours or create new set of audience package.
                                </span>
                                <div className="d-flex gap-5p">
                                    <Input.Search
                                        placeholder="Search Audience Package"
                                        disabled={isSaving}
                                        onChange={(e) => {
                                            setSearchText(e.target.value)
                                        }}
                                    />
                                    <Button
                                        disabled={!selectedLOB || isSaving}
                                        type="primary"
                                        style={{ minWidth: "unset" }}
                                        onClick={() => {
                                            setCreateNew(true);
                                            setAudienceName(toAddNewAudienceName || "");
                                        }}
                                    >
                                        Create New Audience Package
                                    </Button>
                                </div>
                            </div>
                            <div className="report--addaudience--content--audiencecont flex-1">
                                <RenderComponent
                                    show={!toDisplayAudience.length}
                                    loadingProps={{
                                        loading: loadingSearch,
                                        loadingText: "Searching...",
                                    }}
                                    emptyProps={{
                                        className: "d-flex-col align-items-center justify-content-center",
                                        style: {
                                            height: "100%"
                                        },
                                        description: (
                                            <span className="fs-12 fw-400 c-bg-400">
                                                {(searchText && !toDisplayAudience.length) ? "No Result Found."
                                                    : isLoadingAudienceList
                                                        ? "Getting Audience List..."
                                                        : "Select advertiser and line of business above to view the list of your audience package here."}
                                            </span>
                                        )
                                    }}

                                >
                                    <Radio.Group
                                        value={selectedAudience}
                                        style={{ width: "calc(100% - 2mm)", height: "100%" }}
                                        onChange={(e) => {
                                            setSelectedAudience(e.target.value);
                                        }}
                                    >
                                        <Space direction="vertical">
                                            {toDisplayAudience.map((child) => (
                                                <Radio
                                                    key={child.id}
                                                    value={child.id}
                                                    style={{ width: "100%" }}
                                                >
                                                    <span className="audience-item">{child.name}</span>
                                                </Radio>
                                            ))}
                                        </Space>
                                    </Radio.Group>
                                </RenderComponent>
                            </div>
                        </>
                    )}
            </div>
        </Modal>
    );
}

export default AddAudienceModal;
